module.exports = __webpack_public_path__ + "img/拉手锁3.e0ed4aa7.jpg";